import React, { memo,useEffect } from 'react';
import styles from './topOption.module.scss';
import { useNavigate } from 'react-router-dom';
import { UseArticlesState } from '@/store/atoms/articlesState';

export const TopOption = memo(() => {
   const navigate = useNavigate();
   const { setArticlesType,articlesType } = UseArticlesState();
   const i = UseArticlesState();

  const toMcClick = () => {
   setArticlesType('mc')
   navigate('/quesation');
  }

  const toBmClick = () => {
   setArticlesType('bm')
   navigate('/quesation');
  }

  return (
    <div className={styles.option}>
      <button className={`${styles.option_01} ${styles.item}`} onClick={toMcClick}>
        <span className={styles.title}>
          不動産
          <br />
          管理会社様
        </span>
      </button>
      <button className={`${styles.option_02} ${styles.item} ${styles.title}`} onClick={toBmClick}>
        <span className={styles.title}>
          ビルメンテナンス
          <br />
          清掃・水道・電気工事
          <br />
          点検・原状回復会社様
        <span className={styles.sub}>（ 個人事業主 / フリーランス含む）</span>
				</span>
      </button>
    </div>
  );
});
